import { _ } from "../../../../core/polyglot/polyglot.js";
import AccountIntervalGroupRow from "../../reports/rows/AccountIntervalGroupRow.js";
import GeneratedAccountRowTemplate from "./GeneratedAccountRowTemplate.js";
import GroupRowTemplate from "./GroupRowTemplate.js";
import IntervalAccountGroup from "../../../chartOfAccounts/IntervalAccountGroup.js";

/**
 * Group row which leaves are dynamically computed from an account interval.
 *
 * @param {string} spec.interval - String representation of the interval of accounts
 */
export default class AccountIntervalGroupRowTemplate extends GroupRowTemplate {
	constructor({ interval = "" }) {
		super(...arguments);
		this.setInterval(interval);
	}

	getInterval() {
		return this._interval;
	}

	setInterval(interval) {
		this._interval = interval;
		// For efficiency reasons, cache the parsing of the interval string.
		this._parsedInterval = IntervalAccountGroup.parseInterval(interval);
	}

	isAccountIntervalGroupRow() {
		return true;
	}

	canHaveChildren() {
		return false;
	}

	accept(visitor) {
		return visitor.visitAccountIntervalGroupRowTemplate(this);
	}

	_instanceClass() {
		return AccountIntervalGroupRow;
	}

	_interpretationSpec(interpreter) {
		const spec = super._interpretationSpec(...arguments);
		const context = interpreter.getContext();

		const intervalTemplates =
			GeneratedAccountRowTemplate.makeRowTemplatesFromAccounts({
				accounts: this._expandInterval(context),
				parent: this,
			});

		spec.rows = interpreter.interpretItemTemplates(intervalTemplates);
		spec.intervals = this._parsedInterval;

		return spec;
	}

	/**
	 * Return the list of accounts in the interval, for an interpretation
	 * context.
	 */
	_expandInterval(context) {
		const accounts = context.getAccounts();
		return this._parsedInterval.flatMap((interval) =>
			accounts.filter((account) => account.isInInterval(interval)),
		);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.interval = this._interval;

		return properties;
	}

	static getLabel() {
		return _("Account interval group");
	}

	static getType() {
		return "AccountIntervalGroupRowTemplate";
	}
}
